// import Select from "react-select";
// import { components } from "react-select";
// import SortableMultiValue from "./SortableMultiValue";
// import SortableValueContainer from "./SortableValueContainer";

// export default function SortableSelect(props) {
//   return (
//     <Select
//       {...props}
//       isMulti
//       isClearable
//       closeMenuOnSelect={false}
//       components={{
//         ...components,
//         MultiValue: SortableMultiValue,
//         ValueContainer: SortableValueContainer,
//       }}
//     />
//   );
// }

import Select from "react-select";
import { components } from "react-select";
import SortableMultiValue from "./SortableMultiValue";
import SortableValueContainer from "./SortableValueContainer";

export default function SortableSelect(props) {
  return (
    <Select
      {...props}
      isMulti
      isClearable
      closeMenuOnSelect={false}
      components={{
        ...components,
        MultiValue: SortableMultiValue,
        ValueContainer: SortableValueContainer,
      }}
    />
  );
}
